import { render, staticRenderFns } from "./spec-search-bar.vue?vue&type=template&id=246edba6&scoped=true&"
import script from "./spec-search-bar.vue?vue&type=script&lang=js&"
export * from "./spec-search-bar.vue?vue&type=script&lang=js&"
import style0 from "./spec-search-bar.vue?vue&type=style&index=0&id=246edba6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246edba6",
  null
  
)

export default component.exports